import { render } from "./blog-list.vue?vue&type=template&id=3b61b062"
import script from "./blog-list.vue?vue&type=script&lang=js"
export * from "./blog-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__